
// Crie um arquivo pages/SystemHubVendasPage.js
import React from 'react';
import SystemHubModalVendas from '../components/SystemHubModalVendas';
import { useNavigate } from 'react-router-dom';

export default function SystemHubVendasPage() {
    const navigate = useNavigate();
    // Ao fechar, volta para o dashboard do system hub
    return <SystemHubModalVendas onClose={() => navigate('/system-hub/dashboard')} />;
}